import * as yup from "yup";

export const categorySchema = yup
    .object({
        name: yup
            .string()
            .required("Il nome è obbligatorio")
            .trim(),
        description: yup
            .string()
            .trim(),
        image: yup
            .string()
            .trim(),
        image_id: yup
            .string()
            .trim()
    });

export const categorySchemaEdit = yup
    .object({
        name: yup
            .string()
            .nullable(),
        description: yup
            .string()
            .nullable(),
        image: yup
            .string()
            .nullable(),
        image_id: yup
            .string()
            .nullable(),
    });
